import React from 'react';

import { Modal } from '@mui/material/';

import { ReactComponent as CloseIcon } from '../../../assets/icons/close-icon.svg';
import CustomBackdrop, { ICustomBackdropProps } from '../CustomBackdrop/CustomBackdrop';

import './CustomModalNE.scss';

interface ICustomModalProps {
  handleClose: (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => void;
  open: boolean;
  customClass?: string;
  closeButton?: boolean;
}

const CustomModalNE = ({
  open,
  handleClose,
  customClass,
  closeButton = true,
  children
}: React.PropsWithChildren<ICustomModalProps>) => {
  return (
    <Modal
      open={open}
      disableAutoFocus={true}
      disableEnforceFocus={true}
      onClose={handleClose}
      disableScrollLock={false}
      slots={{ backdrop: CustomBackdrop }}
      slotProps={{ backdrop: { handleClose } as ICustomBackdropProps }}
    >
      <div className={`custom-modal-container-ne ${customClass ?? ''}`}>
        <div className={`custom-modal-content ${customClass ?? ''}`}>
          {closeButton && (
            <CloseIcon className="custom-modal-close" onClick={handleClose} data-testid="close-modal-button" />
          )}
          {children}
        </div>
      </div>
    </Modal>
  );
};

export default CustomModalNE;
